/** Dispatched from hero CTAs etc. to open the topbar browse categories UI. */
export const OPEN_BROWSE_MEGA_MENU = 'promotix:open-browse-mega-menu';

export const dispatchOpenBrowseMegaMenu = () => {
  if (typeof window === 'undefined') {
    return;
  }
  window.dispatchEvent(new CustomEvent(OPEN_BROWSE_MEGA_MENU));
};

export const subscribeOpenBrowseMegaMenu = handler => {
  if (typeof window === 'undefined') {
    return () => {};
  }
  window.addEventListener(OPEN_BROWSE_MEGA_MENU, handler);
  return () => window.removeEventListener(OPEN_BROWSE_MEGA_MENU, handler);
};
